import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface CancelIconProps extends SvgIconProps {}

export const CancelIcon = ({
  style,
  ...iconProps
}: CancelIconProps): ReactElement => {
  style = {
    fontSize: '1em',
    ...style,
  };

  return (
    <SvgIcon style={style} {...iconProps} viewBox="0 0 23 23">
      <g fill="#fff" stroke="currentColor" strokeWidth="2">
        <circle cx="11.5" cy="11.5" r="11.5" stroke="none" />
        <circle cx="11.5" cy="11.5" r="10.5" fill="none" />
      </g>
      <path
        d="M16.885,8.445,15.94,7.5l-3.747,3.747L8.445,7.5,7.5,8.445l3.747,3.747L7.5,15.94l.945.945,3.747-3.747,3.747,3.747.945-.945-3.747-3.747Z"
        transform="translate(-0.5 -0.349)"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
      />
    </SvgIcon>
  );
};
